const OrderTrack = () =>import('@/views/orders/track/track')

export default [
  {
    path: '/orders/track/:id',
    name: 'Rastreio',
    component:  OrderTrack,
  }
]
